export default __webpack_public_path__ + "static/media/card-8.c7103e77.png";